<template lang="pug">
section
  .container.custom_container_lg
    .row
      breadcrumb
  .container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-lg-left
        h2.title.bottom_line 公益足跡
    news-item(
      v-for="(news, index) in currentPublicWelfareList",
      :key="index",
      :news="news",
      :direction="index % 2",
      :type="'publicWelfare'"
    )
    .row.i_mt_8
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="perPage",
          first-number,
          last-number
        )
</template>

<script>
import NewsItem from "@/components/about_us/news/NewsItem";
import { getPublicWelfare } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsSocialResponsibilityNews",
  components: {
    breadcrumb: Breadcrumb,
    "news-item": NewsItem,
  },
  data() {
    return {
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      publicWelfare: {},
      currentPublicWelfareList: [],
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getPublicWelfare();
  },
  methods: {
    getPublicWelfare() {
      getPublicWelfare().then((response) => {
        this.publicWelfare = response.data;
        this.totalRows = this.publicWelfare.PublicWelfareList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentPublicWelfareList = [];
      let number = this.perPage * this.currentPage;
      this.currentPublicWelfareList = this.publicWelfare.PublicWelfareList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/about_us/social_responsibility/common";
@import "@/assets/style/about_us/news";
</style>
